// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2AXSK","productName":"Table_productName__1RhLk"};